import { AbstractControl, ValidatorFn } from '@angular/forms';

export function autoCompleteRequired(): ValidatorFn {
  return (control: AbstractControl) => {
    return control.value && typeof control.value == 'string'
      ? { autoCompleteRequired: true }
      : null;
  };
}
